import { translate } from '@jsverse/transloco';
import { createSelector } from '@ngrx/store';

import { Drawing } from '@cdba/shared/models';

import { selectDetailState } from '../../../reducers';
import { DetailState } from '../../../reducers/detail/detail.reducer';

export const getDrawings = createSelector(
  selectDetailState,
  (state: DetailState): Drawing[] => state.drawings.items
);

export const getDrawingsLoading = createSelector(
  selectDetailState,
  (state: DetailState) => state.drawings.loading
);

export const getDrawingsError = createSelector(
  selectDetailState,
  (state: DetailState) => {
    if (state.drawings.errorMessage) {
      return state.drawings.errorMessage;
    }

    if (!state.drawings.loading && state.drawings.items?.length === 0) {
      return translate('detail.drawings.noDrawingsText');
    }

    return undefined;
  }
);

export const getNodeIdOfSelectedDrawing = createSelector(
  selectDetailState,
  (state: DetailState) => state.drawings.selected?.nodeId
);
